"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function prepareQuestions(questions) {
    return lodash_1.shuffle(questions).map(function (question, index) { return (__assign(__assign({}, question), { index: index })); });
}
exports.prepareQuestions = prepareQuestions;
var GROUP_TO_PAGE_KEY_LOOKUP = {
    Inhibition: "inhibition",
    Initiation: "initiation",
    Shifting: "shifting",
    "Emotional Control": "emotional-control",
    "Planning and Organization": "planning-and-organization",
    "Materials Organization": "materials-organization",
    "Working Memory": "working-memory",
    "Self-Monitoring": "self-monitoring",
};
function mapGroupToPageKey(group) {
    var pageKey = GROUP_TO_PAGE_KEY_LOOKUP[group];
    return pageKey;
}
exports.mapGroupToPageKey = mapGroupToPageKey;
//# sourceMappingURL=utils.js.map